//import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import clsx from 'clsx'
import { Text } from '../../../../ui'
import { useContext, useEffect, useMemo, useState } from 'react'
import { formatCurrency } from '../../../../../utils/formatter'
import { OrganizationAPI } from '../../../../../../api/organization.api'
import GlobalContext from '../../../../../../context/global-context'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { getGestionMovementAmounts, parseGestionAmount as parseAmount } from './gestionAmounts'

const getDocumentQuantity = item => {
  const code = Number(item?.code)
  const quantityCandidates = [
    item?.cantidadDocumentos,
    item?.cantidad_documentos,
    item?.cantidadDocs,
    item?.cantidad_docs,
    item?.cantidadOperaciones,
    item?.cantidad_operaciones,
    item?.numeroDocumentos,
    item?.numero_documentos,
    item?.documentCount,
    item?.documentsCount,
    item?.cantidad
  ]

  if ([39, 41, 48].includes(code)) {
    quantityCandidates.push(
      item?.numeroFolio,
      item?.folio,
      item?.numero,
      item?.documentos,
      item?.totalOperaciones,
      item?.total_operaciones
    )
  }

  const quantity = quantityCandidates
    .map(parseAmount)
    .find(value => Number.isFinite(value) && value > 0)

  return quantity ?? 1
}

const formatDiasVencimiento = diasVencimiento => {
  if (diasVencimiento == null || diasVencimiento === '') return ''
  return `${diasVencimiento} días`
}

const getDiasVencimientoValue = (rowDiasVencimiento, empresaDiasVencimiento) => {
  if (rowDiasVencimiento != null && rowDiasVencimiento !== '') return rowDiasVencimiento
  return empresaDiasVencimiento
}

const getContactValue = value => {
  if (value == null) return ''
  return String(value).trim()
}

const TableListado = ({
  tipo,
  onSelectItem,
  dataClienteProv,
  userMe,
  onLoadingEmpresasChange
}) => {
  const [dataEmpresa, setDataEmpresa] = useState({})
  const { currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const styles = {
    table:
      'w-full min-w-[820px] table-auto text-[0.65rem] sm:text-[0.725rem] border-collapse leading-tight font-sans',
    thead: 'sticky top-0 z-10 bg-white',
    th: 'py-2 px-1 sm:px-2 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.55rem] sm:text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-200 hover:bg-gray-100/50',
    td: 'py-2 px-1 sm:px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.6rem] sm:text-[0.65rem]',
    text: 'text-[0.6rem] sm:text-[0.705rem] text-gray-500'
  }

  const firstColName = tipo === 'clientes' ? 'Cliente' : 'Proveedor'
  const balanceColName = tipo === 'clientes' ? 'Saldo por Cobrar' : 'Saldo por Pagar'

  const orderableCols = [
    { col: firstColName, field: 'cliente' },
    { col: 'Rut', field: 'rut' },
    { col: 'Datos Contacto', field: 'datosContacto' },
    { col: 'Plazo Pago', field: 'plazoPago' },
    { col: 'Total Facturado', field: 'totalFacturado' },
    { col: balanceColName, field: 'saldoCobrar' }
  ]

  const { tableData } = useMemo(() => {
    if (!dataClienteProv) {
      return {
        tableData: [],
        clientesCode61: [],
        movimientosClientes: [],
        movimientosCode61: [],
        code61PorMes: []
      }
    }

    const filtered = dataClienteProv.filter(item =>
      tipo === 'clientes'
        ? item.tipo?.toLowerCase() === 'cliente'
        : item.tipo?.toLowerCase() === 'proveedores'
    )

    const grouped = {}
    const grouped61 = {}
    const grouped61ByMonth = {}
    const allMovimientos = []
    const only61Movimientos = []

    const CODE_FALLBACK_NAMES = {
      39: 'Total Oper. del mes Boleta Electr.',
      41: 'Total Op. del mes Boleta Exenta Electr.',
      48: 'Total mes Comprobantes Pago Electrónico'
    }

    filtered.forEach(item => {
      const hasEmpresa = item.razonSocial && item.rut
      const code = Number(item.code)
      const key = hasEmpresa ? `${item.razonSocial}-${item.rut}` : `CODE-${code}`

      const isCode61 = code === 61
      const target = isCode61 ? grouped61 : grouped
      const amounts = getGestionMovementAmounts(item)

      if (!target[key]) {
        target[key] = hasEmpresa
          ? {
              nombre: item.razonSocial,
              rut: item.rut,
              totalFacturado: 0,
              cantidadDocumentos: 0,
              saldoPorCobrar: 0,
              idEmpresa: item.idEmpresa,
              id: item.id,
              idPrincipal: item.idPrincipal,
              tipo: item.tipo,
              nombreFolio: item.nombreFolio,
              code,
              plazoPago: item.plazoPago ?? '',
              diasVencimiento: item.diasVencimiento ?? ''
            }
          : {
              nombre: CODE_FALLBACK_NAMES[code] || `Código ${code}`,
              rut: null,
              totalFacturado: 0,
              cantidadDocumentos: 0,
              saldoPorCobrar: 0,
              idEmpresa: null,
              id: item.id ?? null,
              idPrincipal: item.idPrincipal ?? null,
              tipo: item.tipo,
              nombreFolio: item.nombreFolio,
              code,
              plazoPago: item.plazoPago ?? '',
              diasVencimiento: item.diasVencimiento ?? ''
            }
      }

      if (!target[key].plazoPago && item.plazoPago) {
        target[key].plazoPago = item.plazoPago
      }

      if (
        (target[key].diasVencimiento == null || target[key].diasVencimiento === '') &&
        item.diasVencimiento != null &&
        item.diasVencimiento !== ''
      ) {
        target[key].diasVencimiento = item.diasVencimiento
      }

      target[key].totalFacturado += amounts.totalFacturado
      target[key].saldoPorCobrar += amounts.saldoPorCobrar
      if (!String(item?.libro?.status ?? item?.status ?? '').toUpperCase().includes('ANULA')) {
        target[key].cantidadDocumentos += getDocumentQuantity(item)
      }

      allMovimientos.push(item)
      if (isCode61) {
        only61Movimientos.push(item)
      }

      const getAmount = value => {
        if (typeof value === 'number') return value
        if (typeof value === 'string') return parseAmount(value)
        return 0
      }

      if (isCode61 && item.fecha) {
        const date = new Date(item.fecha)
        const monthKey = `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(
          2,
          '0'
        )}`

        const monthAmount = getAmount(item.montoTotal)

        if (!grouped61ByMonth[monthKey]) {
          grouped61ByMonth[monthKey] = { mes: monthKey, cantidadMovimientos: 0, totalMonto: 0 }
        }
        grouped61ByMonth[monthKey].cantidadMovimientos += getDocumentQuantity(item)
        grouped61ByMonth[monthKey].totalMonto += monthAmount
      }
    })

    return {
      tableData: Object.values(grouped).sort((a, b) =>
        a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
      ),
      clientesCode61: Object.values(grouped61).sort((a, b) =>
        a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
      ),
      movimientosClientes: allMovimientos,
      movimientosCode61: only61Movimientos,
      code61PorMes: Object.values(grouped61ByMonth).sort((a, b) => a.mes.localeCompare(b.mes))
    }
  }, [dataClienteProv, tipo])

  const DOC_NAMES = {
    39: 'Total Oper. del mes Boleta Electr.',
    41: 'Total Op. del mes Boleta Exenta Electr.',
    48: 'Total mes Comprobantes Pago Electrónico',
    61: 'Nota de Crédito Electrónica'
  }

  const agruparPorMesYDoc = (movimientos, codesPermitidos) => {
    const map = {}

    movimientos.forEach(item => {
      const code = Number(item.code)
      if (!codesPermitidos.includes(code)) return

      const fechaRaw = item.fecha || item.fechaEmision || item.fechaDocumento
      if (!fechaRaw) return

      const date = new Date(fechaRaw)
      const mes = `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`
      const docNombre = DOC_NAMES[code] || `Código ${code}`
      const key = `${mes}-${code}`
      const monto = parseAmount(item.montoTotal)

      if (!map[key]) {
        map[key] = {
          mes,
          doc: docNombre,
          code,
          cantidad: 0,
          monto: 0
        }
      }

      map[key].cantidad += getDocumentQuantity(item)
      map[key].monto += monto
    })

    return Object.values(map).sort((a, b) => a.mes.localeCompare(b.mes))
  }

  useEffect(() => {
    let active = true

    const getDatosEmpresas = async () => {
      if (!currentBusiness?.id) {
        setDataEmpresa({})
        onLoadingEmpresasChange?.(false)
        return
      }

      const rowsWithEmpresa = tableData.filter(row => row?.idEmpresa)
      if (!rowsWithEmpresa.length) {
        setDataEmpresa({})
        onLoadingEmpresasChange?.(false)
        return
      }

      onLoadingEmpresasChange?.(true)
      try {
        const responses = await Promise.allSettled(
          rowsWithEmpresa.map(row => {
          const typeValue =
            row.nombreFolio === 'Boleta'
              ? 'honorario'
              : row.tipo === 'Proveedores'
                ? 'compra'
                : 'venta'

            return organizationAPI.getEmpresa({
              businessId: currentBusiness.id,
              idEmpresa: row.idEmpresa,
              type: typeValue
            })
          })
        )

        if (!active) return
        const map = {}
        responses.forEach((result, index) => {
          const idEmpresa = rowsWithEmpresa[index].idEmpresa
          if (result.status === 'fulfilled') {
            const response = result.value
            map[idEmpresa] = response.data ?? response.tableData ?? {}
          } else {
            console.error(`Error al obtener datos de empresa ${idEmpresa}`, result.reason)
            map[idEmpresa] = {}
          }
        })
        setDataEmpresa(map)
      } finally {
        if (active) onLoadingEmpresasChange?.(false)
      }
    }

    getDatosEmpresas()
    return () => {
      active = false
    }
  }, [currentBusiness?.id, onLoadingEmpresasChange, tableData])

  const handleRowClick = row => {
    const code = Number(row.code)
    let resumenPorMes = []

    if (code === 48) resumenPorMes = agruparPorMesYDoc(dataClienteProv, [48])
    if (code === 41) resumenPorMes = agruparPorMesYDoc(dataClienteProv, [41])
    if (code === 39) resumenPorMes = agruparPorMesYDoc(dataClienteProv, [39, 61])

    onSelectItem({
      ...row,
      resumenPorMes
    })
  }

  if (isMobile) {
    return (
      <div className='space-y-3 font-sans'>
        {tableData.map((row, i) => {
          const empresaExtra = dataEmpresa[row.idEmpresa] || {}
          const contact = getContactValue(empresaExtra.contact)
          const mail = getContactValue(empresaExtra.mail)
          const phone = getContactValue(empresaExtra.phone)
          const hasContactData = Boolean(contact || mail || phone)
          const displayPlazoPagoValue =
            row.plazoPago ||
            formatDiasVencimiento(
              getDiasVencimientoValue(row.diasVencimiento, empresaExtra.diasVencimiento)
            )

          return (
            <div
              key={i}
              className='rounded-2xl border border-gray-100 bg-white shadow-sm p-3'
              onClick={() => handleRowClick(row)}
              role='button'
              tabIndex={0}
              onKeyDown={e => e.key === 'Enter' && handleRowClick(row)}
            >
              <div className='flex items-start justify-between gap-2'>
                <div>
                  <Text className='text-xs font-bold'>{row.nombre || 'Clientes Varios'}</Text>
                  <Text className='text-[11px] text-gray-500'>{row.rut || 'Rut Varios'}</Text>
                </div>
                <Text className='text-xs font-semibold'>
                  {formatCurrency(row.totalFacturado)}
                </Text>
              </div>

              <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
                <div>
                  <Text className='text-[10px] text-gray-400'>Contacto</Text>
                  {hasContactData ? (
                    <>
                      {contact && <Text className='text-xs font-semibold'>{contact}</Text>}
                      {mail && <Text className='text-[11px] text-gray-500'>{mail}</Text>}
                      {phone && <Text className='text-[11px] text-gray-500'>{phone}</Text>}
                    </>
                  ) : (
                    <Text className='text-xs font-semibold'>Sin Contacto</Text>
                  )}
                </div>
                <div className='text-right'>
                  <Text className='text-[10px] text-gray-400'>{balanceColName}</Text>
                  <Text className='text-xs font-semibold'>
                    {formatCurrency(row.saldoPorCobrar)}
                  </Text>
                  <Text className='text-[10px] text-gray-400 mt-2'>Plazo Pago</Text>
                  <Text className='text-xs font-semibold'>{displayPlazoPagoValue}</Text>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className='overflow-x-auto'>
      <div className='h-full mt-2'>
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              {orderableCols.map(({ col, field }, i) => (
                <th
                  key={i}
                  className={clsx(styles.th, { 'cursor-pointer': field }, i === 0 && styles.smallCol)}
                  onClick={() => field}
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={styles.tbody}>
            {tableData.map((row, i) => {
              const empresaExtra = dataEmpresa[row.idEmpresa] || {}
              const contact = getContactValue(empresaExtra.contact)
              const mail = getContactValue(empresaExtra.mail)
              const phone = getContactValue(empresaExtra.phone)
              const hasContactData = Boolean(contact || mail || phone)
              const displayPlazoPagoValue =
                row.plazoPago ||
                formatDiasVencimiento(
                  getDiasVencimientoValue(row.diasVencimiento, empresaExtra.diasVencimiento)
                )

              return (
                <tr className={clsx(styles.tr)} key={i} onClick={() => handleRowClick(row)}>
                  <td className={styles.td}>
                    <Text className={styles.boldText}>{''}</Text>
                    <Text className={styles.boldText}>{row.nombre || 'Clientes Varios'}</Text>
                    <Text className={styles.boldText}>{''}</Text>
                  </td>

                  <td className={clsx(styles.td)}>
                    <Text className={styles.boldText}>{row.rut || 'Rut Varios'}</Text>
                  </td>

                  <td className={styles.td}>
                    {hasContactData ? (
                      <>
                        {contact && <Text className={styles.boldText}>{contact}</Text>}
                        {mail && <Text className={styles.text}>{mail}</Text>}
                        {phone && <Text className={styles.text}>{phone}</Text>}
                      </>
                    ) : (
                      <Text className={styles.boldText}>Sin Contacto</Text>
                    )}
                  </td>

                  <td className={styles.td}>
                    <Text className={styles.boldText}>{displayPlazoPagoValue || <>&nbsp;</>}</Text>
                  </td>

                  <td className={styles.td}>
                    <Text className={styles.boldText}>{formatCurrency(row.totalFacturado)}</Text>
                  </td>

                  <td className={styles.td}>
                    <Text className={styles.boldText}>{formatCurrency(row.saldoPorCobrar)}</Text>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TableListado
